import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import {
  ResponsivePageView,
  useOutageResponsivePageTracker,
} from '../../providers/OutageResponsivePageTracker';
import { useIsMobile } from '../../../../util/style-utils';
import { OutageMapLegends } from '../outage-map-legends';
import { Position } from '../../types';
import { OutageMapSection } from '../outage-map-section';

export const OutageCenterMap = () => {
  const [currentUserLocation, setCurrentUserLocation] = useState<Position>();
  const isMobile = useIsMobile();
  const { page } = useOutageResponsivePageTracker();

  return (
    <Box
      data-testid="outage-map-container"
      visibility={
        isMobile && page !== ResponsivePageView.Map ? 'hidden' : 'visible'
      }
      width={'100%'}
      height={'calc(100vh - 72px)'}
      position={'absolute'}
    >
      <OutageMapLegends setCurrentUserLocation={setCurrentUserLocation} />

      <OutageMapSection currentUserLocation={currentUserLocation} />
    </Box>
  );
};
